// extracted by mini-css-extract-plugin
export default {"whatWeDo":"BrowseVideo_whatWeDo__xUOVM","title":"BrowseVideo_title__cUcj8","options":"BrowseVideo_options__VEGJ4","btn":"BrowseVideo_btn__H6qda","icon":"BrowseVideo_icon__Y77NZ"};